import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
} from '@gpstrackit/react-controls';

import { deleteDealerWebhook, reset, openModalDeleteWebHook } from './redux/slice';
import { NotificationManager } from 'Components/Notifications';

const DeleteWebHook = ({ tableRef }) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();

    const { loading, openModal, result, dealerId, webhook, error } = useSelector(
        state => state.deleteWebHookRedux
    );

    useEffect(() => {
        if (result?.success && !loading) {
            NotificationManager.success(
                messages['delete_webhook_success'] || 'Webhook deleted successfully'
            );
            dispatch(reset({ openModal: false }));
            if (tableRef?.current?.getData) {
                tableRef.current.getData({});
            }
        }
    }, [result, loading]);

    useEffect(() => {
        if (error && !loading) {
            NotificationManager.error(
                error || messages['delete_webhook_error'] || 'Failed to delete webhook'
            );
        }
    }, [error, loading]);

    const handleDelete = () => {
        dispatch(deleteDealerWebhook({
            dealerId,
            id: webhook?.id,
        }));
    };

    const handleClose = () => {
        dispatch(reset({ openModal: false }));
    };

    return (
        <Modal
            open={openModal}
            title={messages['delete_webhook_title'] || 'Delete Webhook'}
            position="right"
            size="small"
            handleClose={handleClose}
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>
                    <div style={{ margin: 10 }}>
                        <p>{messages['delete_webhook_confirm'] || 'Are you sure you want to delete this webhook?'}</p>
                    </div>
                    <div style={{ margin: 10 }}>
                        <p style={{ fontSize: '12px', color: '#666' }}>
                            {webhook?.name}
                        </p>
                    </div>
                </div>
            </ModalBody>

            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={handleClose}
                >
                    {messages['common_cancel'] || 'Cancel'}
                </Button>
                <Button
                    className="btn btn-dark-blue"
                    onClick={handleDelete}
                    disabled={loading}
                >
                    {messages['common_delete'] || 'Delete'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default DeleteWebHook;
